jQuery_T4NT(document).ready(function($) {
  // any code js
  if(Modernizr.hovermq == false){
    $('#nt_menu_id .has-children').removeClass('has-children');
  }
  
  /*
  window.RevyBundle.api.getTotal(response => {
		console.log("REVY");
    	console.log(response)
  });
  */
  window.revyBundleDataLayer = window.revyBundleDataLayer || []; 
  window.revyBundleDataLayer.push({onReady: function() {   	
      //console.log("Bundle onReady"); 
      setTimeout(function(){
        getTotals();
      }, 2000);
  	}
  });
  
  window.revyBundleDataLayer.push({onAddBundle: function(response) {
  	console.log("Bundle: onAddBundle");
	console.log(response);
    geckoShopify.onCartUpdate(1,1,response.items[0].product.product_id);
  }})
  
  $(document).on("ld_bar_end", function(){
  	//console.log("clcik");
    //getTotals();
     console.log("ld_bar_end..");
     getTotals();	
  });
  if($(".nt_action .my-account ul").length==0){
    document.cookie = "b2bredirect=;max-age=-1";
  }
  if($(".nt_action .my-account ul").length>0 && document.location.href.indexOf('pages/profesional')>0){
    document.location.href="/account";
  }
});

function getTotals(){
	window.RevyBundle.api.getTotal(response => {
    console.log(response);
    
      if(response.bundleTotal.per_variant){
          var variants = response.bundleTotal.per_variant;

          for(var i = 0; i < variants.length; i++){
            var newEl = 'cart_item_changed_' + variants[i].key.replace(":", "_");
            $("#cart_meta_price_" + variants[i].key.replace(":", "_") + ">.cart_price").css({"text-decoration": "line-through", "display": "inline"}).addClass("promo-price1");
            if($('.' + newEl).length == 0)
            {
            	$("#cart_meta_price_" + variants[i].key.replace(":", "_")).append($('<div class="cart_price_new ' + newEl + '">' + variants[i].formatted.final + '</div>').css({"display": "inline", "color": "#FA0D0D"}));
            }
            else{
            	$('.' + newEl).html(variants[i].formatted.final);
            }
          }

          $(".cart_tot_price").css({"text-decoration": "line-through"});
          $(".js_cat_ttprice ").append($('<div class="cart_tot_price tdf-cart-total-parent">' + response.bundleTotal.formatted.final  +'</div>').css({"color": "#FA0D0D"}));	
      } else {
          $(".cart_price_new").hide();
        $(".promo-price1").css({"text-decoration": "none"});
      }

    });
}
